import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../../commonComponents/translate';
import CheckIcon from '../../../../commonComponents/icons/CheckIcon';
import LockIcon from '../../../../commonComponents/icons/LockIcon';

const LevelCard = props => {
  const { t, index, levelData } = props;

  const {
    level,
    skillLevel,
    strongLeg,
    weakLeg,
    conditionsStrongLeg,
    conditionsWeakLeg,
  } = levelData;

  const isLevelComplete = cardIndex => {
    if (cardIndex === 0) {
      return level > 0;
    }
    return false;
  };

  const isStageComplete = stageObject => stageObject.limitAchieved;

  /*
  // was being used before when the checks had different colors
  const getCardCheckColor = cardIndex => {
    if (cardIndex === 0) {
      return '#3FBC5F';
    }
    return '#3FBC5F';
  };
  */

  const daysLeft = () => {
    const endOfMonth = moment().endOf('month');

    return endOfMonth.diff(moment(), 'days');
  };

  const levelProgress = () => {
    const daysInMonth = moment().daysInMonth();

    return (moment().format('DD') * 100) / daysInMonth;
  };

  return (
    <div className={`level-card card-${index + 1}`}>
      {isLevelComplete(index) && (
        <div className="cardBookmark">
          <span className="cardBookmarkText">
            {t('report.arcova.levelCompleted')}
            <img
              src="/images/reports/party-hat.svg"
              alt="yay"
              className="partyHat"
            />
          </span>
        </div>
      )}
      <div className="cardHeader">
        {index === 2 && (
          <div className="cardLockContainer">
            <LockIcon width={76} height={96} />
          </div>
        )}
        <span className="levelLabel">
          {t('report.arcova.level')} {level}
        </span>
        <img
          src={skillLevel.icon}
          alt={skillLevel.name}
          className="level-card-image"
        />
        {isLevelComplete(index) && (
          <div className="completedLevelCheck">
            <CheckIcon />
          </div>
        )}
        <span className="levelLabelName">{skillLevel.name}</span>
        {index === 1 && (
          <div className="progress">
            <div
              className="progress-bar"
              role="progressbar"
              style={{
                width: `${levelProgress()}%`,
              }}
            >
              {daysLeft()} {t('report.arcova.daysLeft')}
            </div>
          </div>
        )}
      </div>
      <div className="cardTableBody">
        <table className="table" style={{ width: '100%' }}>
          <tbody>
            <tr className="content" key="row-1">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {isStageComplete(strongLeg) && <CheckIcon color="#3FBC5F" />}
                </div>
                <span className="contentCellText">
                  {strongLeg && strongLeg.limit}
                </span>
              </td>
            </tr>
            <tr className="content" key="row-2">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {isStageComplete(weakLeg) && <CheckIcon color="#3FBC5F" />}
                </div>
                <span className="contentCellText">
                  {weakLeg && weakLeg.limit}
                </span>
              </td>
            </tr>
            <tr className="content" key="row-3">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {isStageComplete(conditionsStrongLeg) && (
                    <CheckIcon color="#3FBC5F" />
                  )}
                </div>
                <span className="contentCellText">
                  {conditionsStrongLeg && conditionsStrongLeg.limit}
                </span>
              </td>
            </tr>
            <tr className="content" key="row-4">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {isStageComplete(conditionsWeakLeg) && (
                    <CheckIcon color="#3FBC5F" />
                  )}
                </div>
                <span className="contentCellText">
                  {conditionsWeakLeg && conditionsWeakLeg.limit}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

LevelCard.propTypes = {
  t: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  levelData: PropTypes.shape({
    level: PropTypes.number.isRequired,
    skillLevel: PropTypes.shape({
      icon: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    strongLeg: PropTypes.shape({
      limit: PropTypes.number,
      limitAchieved: PropTypes.bool,
    }).isRequired,
    weakLeg: PropTypes.shape({
      limit: PropTypes.number,
      limitAchieved: PropTypes.bool,
    }).isRequired,
    conditionsStrongLeg: PropTypes.shape({
      limit: PropTypes.string,
      limitAchieved: PropTypes.bool,
    }).isRequired,
    conditionsWeakLeg: PropTypes.shape({
      limit: PropTypes.string,
      limitAchieved: PropTypes.bool,
    }).isRequired,
  }).isRequired,
};

export default translate(LevelCard);
